export const TEMPLATE_PATH = "/files/pickup_accounts_import_template.xlsx";
export const TEMPLATE_ROWS = 1000;
export const TEMPLATE_HEADERS = ["Role name", "Username", "Password", "Account name", "Pickup Type"];
